import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { updateString, updateStringPrint } from 'utils';

import { Link } from 'react-router-dom';
import { parseQuery } from 'utils';
import Switcher from 'containers/Switcher';
import Menu from '../../../common/Menu/Menu';
import Dropdown from '../../../common/Dropdown/Dropdown';
import Housing from '../Filters/Housing/Housing';

// import iconBack from 'assets/images/icons/icon-back.svg';
import iconUpdate from 'assets/images/icons/update-arrows.svg';
import IconTh from 'react-icons/lib/fa/th';
import IconList from 'react-icons/lib/fa/th-list';
import IconListBlue from 'assets/images/icons/icon-list-blue.svg';
import logoPrint from 'assets/images/logo-black.svg';
import { withTranslation } from 'react-i18next';

import cn from 'classnames/bind';
import styles from './BuildingBar.scss';

const cx = cn.bind(styles);

class BuildingBar extends Component {

  constructor(props) {
    super(props);

    this.state = {
      onTop: true
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  supportsPassiveEventListener() {
    let supportsPassiveOption = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll, this.supportsPassiveEventListener() && { passive: true });
  }

  componentDidUpdate() {
    if (ReactDOM.findDOMNode(this).scrollTop !== 0) {
      ReactDOM.findDOMNode(this).scrollTop = 0;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll(event) {
    const scrollTop = event.srcElement.body.scrollTop;
    this.setState({ onTop: scrollTop === 0 });
  }

  // handleListSwitchClick = () => {
  //   this.props.handleList(!this.props.isTable)
  // }

  render() {
    const { className, location, data, chessList, isTable, pavilions, pavilionsFlat, filters, handleFilters, print, handleList, t } = this.props;
    const { id, title } = data || {};

    const section = (parseQuery(location.search).section || '0.0').split('.');
    const sectionId = data && data.pavilions[section[0]].sectionIds[section[1]];
    const { updated } = (chessList && chessList[sectionId]) || {};
    const isChess = !!~location.pathname.indexOf('chess');

    const { section: selectedSectionPath } = filters;

    let pavilion,
      sectionCount,
      selectedPavilion,
      selectedSection,
      deadline,
      isFinished,
      isOnlyOneSectionInSelectedPavilion;
    if (pavilionsFlat && selectedSectionPath) {
      const selectedPavilionId = selectedSectionPath[0];
      selectedPavilion = pavilionsFlat[selectedPavilionId];
      isOnlyOneSectionInSelectedPavilion = selectedPavilion.sections.length === 1;

      const selectedSectionId = selectedSectionPath[1];
      selectedSection = selectedPavilion.sections[selectedSectionId];

      pavilion = pavilions.find((pavilion) => (pavilion.id === selectedPavilion.id));
      const { construction_finished: finished, year_built: year, construction_ending: quarter } = pavilion;

      deadline = finished ? t('components.building.bar.finished') : ((year !== 0) ? (quarter ? `${quarter} / ${year}` : year) : t('components.building.bar.inProcess'));
      isFinished = finished;

      sectionCount = pavilionsFlat.reduce((prev, cur) => (prev + cur.sections.length), 0);
    }

    let updateTime;
    if (updated) {
      if (print) {
        updateTime = updateStringPrint(updated);
      } else if (updateString(updated, print).indexOf('Сегодня') == 0) {
        updateTime = t('components.building.bar.today');
      } else {
        updateTime = updateString(updated);
      }
    }

    return (
      <div className={cx(styles.Toolbar, className, { [styles.ToolbarPrint]: print }, { ToolbarOnTop: this.state.onTop, ToolbarChess: isChess })}>
        {(data && pavilionsFlat) ? (
          <div className={!isChess ? styles.Inner : cn(styles.Inner, styles.Wide)}>
            <div className={cn(styles.Left, styles.Title)}>
              {/* <div className={styles.TitleHousing}> */}
              {/* Корпус 1, секция 1 */}
              {/* <div className={cn((true ? styles.Green : styles.Yellow), styles.StatusBlock)}>Сдан</div> */}
              {/* </div> */}

              <div className={styles.DropdownWrap}>
                {selectedSectionPath ? (
                  <div className={styles.DropdownContent}>
                    <div className={cn(styles.HousingInfo)}>
                      <div className={styles.HousingName}>
                        <span>{`${t('components.building.bar.pavilion')} ${selectedPavilion.name}${isOnlyOneSectionInSelectedPavilion ? '' : `, ${t('components.building.bar.section')} ${selectedSection.name}`}`}</span>
                      </div>
                      <p className={cn(isFinished ? styles.Green : styles.Yellow, styles.StatusBlock)}>{deadline}</p>
                    </div>
                    <p className={styles.ObjectName}>{title}{print ? (`, ${data.address}`) : null}</p>
                  </div>
                  ) : null}
                {sectionCount > 1 ? (
                  <Dropdown
                    leftShift
                    text={''}
                    iconStyle={styles.DropdownIcon}
                    chessfilter="Housing"
                    buttonStyle={styles.DropdownButton}
                    openByClick={true}
                  >
                    <Menu leftArrow pure maxHeight="calc(100vh - 295px)">
                      <Housing pavilions={pavilions} pavilionsFlat={pavilionsFlat} selectedSectionPath={selectedSectionPath} handleFilters={handleFilters} />
                    </Menu>
                  </Dropdown>
                  ) : null}
              </div>

            </div>
            <div className={styles.Right}>
              {
                  updated ?
                    <div
                      className={styles.UpdateTime}
                      data-tip={t('components.building.bar.dateUpdated')}
                      data-for="global"
                    >
                      { print ? t('components.building.bar.dateFrom') : <img alt="icon" src={iconUpdate} /> }
                      <span className={styles.TabletHidden}></span>
                      <span className={cn(styles.Time, { [styles.Print]: print })}>{updateTime}</span>
                    </div> :
                      null
                }
              {/* <button */}
              {/* className={styles.ListSwitcher} */}
              {/* onClick={this.handleListSwitchClick} */}
              {/* > */}
              {/* <img src={IconListBlue} alt=""/> */}
              {/* { isTable ? 'Список квартир' : 'Шахматка' } */}
              {/* </button> */}
              {data.type_id != 2 && <div className={cn(styles.SwitcherInner)}>
                <Switcher
                  defaultChecked={isTable}
                  events={{
                    left: 'Web_List_Checkerboard',
                    right: 'Web_List_Premises'
                  }}
                  eventData={{
                    id,
                    name: title
                  }}
                  rightText={t('components.building.bar.list')}
                  rightUrl="/"
                  leftText={t('components.building.bar.chess')}
                  leftUrl={`${location.pathname}/chess`}
                  leftIcon={<IconTh />}
                  rightIcon={<IconList />}
                  leftTooltip={t('components.building.bar.listTooltip')}
                  rightTooltip={t('components.building.bar.chessTooltip')}
                  elementStyle={'Round'}
                  onClick={handleList}
                  className={styles.SwitcherButtons}
                  enabledStyle={styles.SwitcherEnabled}
                  enabledStyleChecked={styles.SwitcherEnabledChecked}
                  enabledStyleNotChecked={styles.SwitcherEnabledNotChecked}
                  textStyle={styles.SwitcherText}
                />
                </div>}
              <Link to={`${location.pathname.replace('/chess', '')}`} className={cn(styles.ToInfoBtn, 'button-primary', 'button-primary--lg')}>{data.type_id === 2 ? t('components.building.bar.infoAboutKP') : t('components.building.bar.infoAboutJK')}</Link>
            </div>
            {
                  print ? <img src={logoPrint} alt="" className={styles.LogoPrint} /> : null
              }
          </div>
        ) : (
          <div className={styles.WireframeToolbar}>
            <div className={styles.WireframeTitle}>
              <span></span>
              <span></span>
            </div>
            {/* <div className={styles.WireframeTime}></div> */}
            {/* <div className={styles.WireframeSwitcher}></div> */}
            {/* <div className={styles.WireframeInfoButton}></div> */}
          </div>
        )}
      </div>
    );
  }
}

const buildingDataSelector = state => state.building.data;
const chessListSelector = state => state.building.chessList;

const buildingBarSelector = createSelector(
  buildingDataSelector,
  chessListSelector,
  (buildingData, chessList) => ({
    data: buildingData,
    chessList
  })
);

export default withTranslation()(connect(buildingBarSelector)(BuildingBar));



// WEBPACK FOOTER //
// ./src/components/Building/Chess/BuildingBar/BuildingBar.js